import React from 'react'
import ClassNames from 'classnames'
import { Link } from 'react-router-dom'
import { SideBarStyle, SideBarItemStyle } from './styled'
import { Image, Accordion, Section } from '../../components'
import { ROUTE_PATH } from '../../helpers'
import { store } from 'store'
import {
  filterSearchInput,
  filterSearchOptions,
  filterSearchInput1,
  filterSearchOptions2,
  filterSearchOptions3,
  filterSearchOptions4,
  filterSearchSourcingInput1,
  filterSearchSourcingOptions2,
  filterSearchSourcingOptions3,
  filterSearchSourcingOptions4,
  filterSourcingSupplierInput1,
  filterSourcingSupplierOptions2,
  filterSourcingSupplierOptions3,
  filterSourcingSupplierOptions4,
  filterSearchSourcingOptions5,
  filterSourcingSupplierOptionsEventType,
  filterDateFrom,
  filterDateTo,
  filterPage,
  filterPageAllEvent,
  filterStatusSourcingProjects,
  searchEventListSearch,
  searchEventListAllStatus,
  searchEventListAllEventType,
  searchEventListSealStatus,
  searchEventListAllAward,
  searchEventListAllUser,
} from '../../store/actions'

class SideBarItem extends React.Component {
  constructor(props) {
    super(props)
    this.funcClearReduxFilter = this.funcClearReduxFilter.bind(this, true)
    this.state = {
      isSupMenuOpen: false,
      bodyHeight: 0,
      isHover: false,
    }
  }

  funcClearReduxFilter(active, component) {
    const compareComponent = {
      HomeComponent: 'Home',
      companyProfile: 'Company Profile',
      userManagement: 'User Management',
      supplierManagement: 'Supplier Management',
      supplierDiscovery: 'Supplier Discovery',
      riskManagement: 'Risk Management',
      regulatory: 'Regulatory',
      sustainabilityManagement: 'Sustainability Management',
      comprehensiveAssessmentManagement: 'Comprehensive Assessment Management',
      sourcing: 'Sourcing',
    }

    switch (component) {
      case compareComponent.companyProfile:
        {
          if (active) {
            store.dispatch(filterSearchInput(''))
            store.dispatch(filterSearchOptions(''))
            store.dispatch(filterSearchInput1(''))
            store.dispatch(filterSearchOptions2(''))
            store.dispatch(filterSearchOptions3(''))
            store.dispatch(filterSearchOptions4(''))
            // Sourcing Clear filter
            store.dispatch(filterSearchSourcingInput1())
            store.dispatch(filterSearchSourcingOptions2())
            store.dispatch(filterSearchSourcingOptions3())
            store.dispatch(filterSearchSourcingOptions4())
            // Sourcing supplier Clear filter
            store.dispatch(filterSourcingSupplierInput1())
            store.dispatch(filterSourcingSupplierOptions2())
            store.dispatch(filterSourcingSupplierOptions3())
            store.dispatch(filterSourcingSupplierOptions4())
            store.dispatch(filterSourcingSupplierOptionsEventType())
            // seal clear
            store.dispatch(filterSearchSourcingOptions5())
            // clear date from
            store.dispatch(filterDateFrom())
            // clear date to
            store.dispatch(filterDateTo())
            // clear filter Status
            store.dispatch(filterStatusSourcingProjects())
            // clear Sourcing Event
            store.dispatch(searchEventListSearch())
            store.dispatch(searchEventListAllStatus())
            store.dispatch(searchEventListAllEventType())
            store.dispatch(searchEventListSealStatus())
            store.dispatch(searchEventListAllAward())
            store.dispatch(searchEventListAllUser())
            // clear page
            store.dispatch(filterPage())
            store.dispatch(filterPageAllEvent())
          }
        }
        break
      case compareComponent.HomeComponent:
        {
          if (active) {
            store.dispatch(filterSearchInput(''))
            store.dispatch(filterSearchOptions(''))
            store.dispatch(filterSearchInput1(''))
            store.dispatch(filterSearchOptions2(''))
            store.dispatch(filterSearchOptions3(''))
            store.dispatch(filterSearchOptions4(''))
            // Sourcing Clear filter
            store.dispatch(filterSearchSourcingInput1())
            store.dispatch(filterSearchSourcingOptions2())
            store.dispatch(filterSearchSourcingOptions3())
            store.dispatch(filterSearchSourcingOptions4())
            // Sourcing supplier Clear filter
            store.dispatch(filterSourcingSupplierInput1())
            store.dispatch(filterSourcingSupplierOptions2())
            store.dispatch(filterSourcingSupplierOptions3())
            store.dispatch(filterSourcingSupplierOptions4())
            store.dispatch(filterSourcingSupplierOptionsEventType())
            // seal clear
            store.dispatch(filterSearchSourcingOptions5())
            // clear date from
            store.dispatch(filterDateFrom())
            // clear date to
            store.dispatch(filterDateTo())
            // clear filter Status
            store.dispatch(filterStatusSourcingProjects())
            // clear Sourcing Event
            store.dispatch(searchEventListSearch())
            store.dispatch(searchEventListAllEventType())
            store.dispatch(searchEventListAllStatus())
            store.dispatch(searchEventListSealStatus())
            store.dispatch(searchEventListAllAward())
            store.dispatch(searchEventListAllUser())
            // clear page
            store.dispatch(filterPage())
            store.dispatch(filterPageAllEvent())
          }
        }
        break
      case compareComponent.userManagement:
        {
          if (active) {
            store.dispatch(filterSearchInput1(''))
            store.dispatch(filterSearchOptions2(''))
            store.dispatch(filterSearchOptions3(''))
            store.dispatch(filterSearchOptions4(''))
            // Sourcing Clear filter
            store.dispatch(filterSearchSourcingInput1())
            store.dispatch(filterSearchSourcingOptions2())
            store.dispatch(filterSearchSourcingOptions3())
            store.dispatch(filterSearchSourcingOptions4())
            // Sourcing supplier Clear filter
            store.dispatch(filterSourcingSupplierInput1())
            store.dispatch(filterSourcingSupplierOptions2())
            store.dispatch(filterSourcingSupplierOptions3())
            store.dispatch(filterSourcingSupplierOptions4())
            store.dispatch(filterSourcingSupplierOptionsEventType())
            // seal clear
            store.dispatch(filterSearchSourcingOptions5())
            // clear date from
            store.dispatch(filterDateFrom())
            // clear date to
            store.dispatch(filterDateTo())
            // clear filter Status
            store.dispatch(filterStatusSourcingProjects())
            // clear Sourcing Event
            store.dispatch(searchEventListSearch())
            store.dispatch(searchEventListAllEventType())
            store.dispatch(searchEventListAllStatus())
            store.dispatch(searchEventListSealStatus())
            store.dispatch(searchEventListAllAward())
            store.dispatch(searchEventListAllUser())
            // clear page
            store.dispatch(filterPage())
            store.dispatch(filterPageAllEvent())
          }
        }
        break
      case compareComponent.supplierManagement:
        {
          if (active) {
            store.dispatch(filterSearchInput(''))
            store.dispatch(filterSearchOptions(''))
            // Sourcing Clear filter
            store.dispatch(filterSearchSourcingInput1())
            store.dispatch(filterSearchSourcingOptions2())
            store.dispatch(filterSearchSourcingOptions3())
            store.dispatch(filterSearchSourcingOptions4())
            // Sourcing supplier Clear filter
            store.dispatch(filterSourcingSupplierInput1())
            store.dispatch(filterSourcingSupplierOptions2())
            store.dispatch(filterSourcingSupplierOptions3())
            store.dispatch(filterSourcingSupplierOptions4())
            store.dispatch(filterSourcingSupplierOptionsEventType())
            // seal clear
            store.dispatch(filterSearchSourcingOptions5())
            // clear date from
            store.dispatch(filterDateFrom())
            // clear date to
            store.dispatch(filterDateTo())
            // clear filter Status
            store.dispatch(filterStatusSourcingProjects())
            // clear Sourcing Event
            store.dispatch(searchEventListSearch())
            store.dispatch(searchEventListAllEventType())
            store.dispatch(searchEventListAllStatus())
            store.dispatch(searchEventListSealStatus())
            store.dispatch(searchEventListAllAward())
            store.dispatch(searchEventListAllUser())
            // clear page
            store.dispatch(filterPage())
            store.dispatch(filterPageAllEvent())
          }
        }
        break
      case compareComponent.supplierDiscovery:
        {
          if (active) {
            store.dispatch(filterSearchInput(''))
            store.dispatch(filterSearchOptions(''))
            store.dispatch(filterSearchInput1(''))
            store.dispatch(filterSearchOptions2(''))
            store.dispatch(filterSearchOptions3(''))
            store.dispatch(filterSearchOptions4(''))
            // Sourcing Clear filter
            store.dispatch(filterSearchSourcingInput1())
            store.dispatch(filterSearchSourcingOptions2())
            store.dispatch(filterSearchSourcingOptions3())
            store.dispatch(filterSearchSourcingOptions4())
            // Sourcing supplier Clear filter
            store.dispatch(filterSourcingSupplierInput1())
            store.dispatch(filterSourcingSupplierOptions2())
            store.dispatch(filterSourcingSupplierOptions3())
            store.dispatch(filterSourcingSupplierOptions4())
            store.dispatch(filterSourcingSupplierOptionsEventType())
            // seal clear
            store.dispatch(filterSearchSourcingOptions5())
            // clear date from
            store.dispatch(filterDateFrom())
            // clear date to
            store.dispatch(filterDateTo())
            // clear filter Status
            store.dispatch(filterStatusSourcingProjects())
            // clear Sourcing Event
            store.dispatch(searchEventListSearch())
            store.dispatch(searchEventListAllStatus())
            store.dispatch(searchEventListAllEventType())
            store.dispatch(searchEventListSealStatus())
            store.dispatch(searchEventListAllAward())
            store.dispatch(searchEventListAllUser())
            // clear page
            store.dispatch(filterPage())
            store.dispatch(filterPageAllEvent())
          }
        }
        break
      case compareComponent.riskManagement:
        {
          if (active) {
            store.dispatch(filterSearchInput(''))
            store.dispatch(filterSearchOptions(''))
            store.dispatch(filterSearchInput1(''))
            store.dispatch(filterSearchOptions2(''))
            store.dispatch(filterSearchOptions3(''))
            store.dispatch(filterSearchOptions4(''))
            // Sourcing Clear filter
            store.dispatch(filterSearchSourcingInput1())
            store.dispatch(filterSearchSourcingOptions2())
            store.dispatch(filterSearchSourcingOptions3())
            store.dispatch(filterSearchSourcingOptions4())
            // Sourcing supplier Clear filter
            store.dispatch(filterSourcingSupplierInput1())
            store.dispatch(filterSourcingSupplierOptions2())
            store.dispatch(filterSourcingSupplierOptions3())
            store.dispatch(filterSourcingSupplierOptions4())
            store.dispatch(filterSourcingSupplierOptionsEventType())
            // seal clear
            store.dispatch(filterSearchSourcingOptions5())
            // clear date from
            store.dispatch(filterDateFrom())
            // clear date to
            store.dispatch(filterDateTo())
            // clear filter Status
            store.dispatch(filterStatusSourcingProjects())
            // clear Sourcing Event
            store.dispatch(searchEventListSearch())
            store.dispatch(searchEventListAllEventType())
            store.dispatch(searchEventListAllStatus())
            store.dispatch(searchEventListSealStatus())
            store.dispatch(searchEventListAllAward())
            store.dispatch(searchEventListAllUser())
            // clear page
            store.dispatch(filterPage())
            store.dispatch(filterPageAllEvent())
          }
        }
        break
      case compareComponent.sustainabilityManagement:
        {
          if (active) {
            store.dispatch(filterSearchInput(''))
            store.dispatch(filterSearchOptions(''))
            store.dispatch(filterSearchInput1(''))
            store.dispatch(filterSearchOptions2(''))
            store.dispatch(filterSearchOptions3(''))
            store.dispatch(filterSearchOptions4(''))
            // Sourcing Clear filter
            store.dispatch(filterSearchSourcingInput1())
            store.dispatch(filterSearchSourcingOptions2())
            store.dispatch(filterSearchSourcingOptions3())
            store.dispatch(filterSearchSourcingOptions4())
            // Sourcing supplier Clear filter
            store.dispatch(filterSourcingSupplierInput1())
            store.dispatch(filterSourcingSupplierOptions2())
            store.dispatch(filterSourcingSupplierOptions3())
            store.dispatch(filterSourcingSupplierOptions4())
            store.dispatch(filterSourcingSupplierOptionsEventType())
            // seal clear
            store.dispatch(filterSearchSourcingOptions5())
            // clear date from
            store.dispatch(filterDateFrom())
            // clear date to
            store.dispatch(filterDateTo())
            // clear filter Status
            store.dispatch(filterStatusSourcingProjects())
            // clear Sourcing Event
            store.dispatch(searchEventListSearch())
            store.dispatch(searchEventListAllEventType())
            store.dispatch(searchEventListAllStatus())
            store.dispatch(searchEventListSealStatus())
            store.dispatch(searchEventListAllAward())
            store.dispatch(searchEventListAllUser())
            // clear page
            store.dispatch(filterPage())
            store.dispatch(filterPageAllEvent())
          }
        }
        break
      case compareComponent.comprehensiveAssessmentManagement:
        {
          if (active) {
            store.dispatch(filterSearchInput(''))
            store.dispatch(filterSearchOptions(''))
            store.dispatch(filterSearchInput1(''))
            store.dispatch(filterSearchOptions2(''))
            store.dispatch(filterSearchOptions3(''))
            store.dispatch(filterSearchOptions4(''))
            // Sourcing Clear filter
            store.dispatch(filterSearchSourcingInput1())
            store.dispatch(filterSearchSourcingOptions2())
            store.dispatch(filterSearchSourcingOptions3())
            store.dispatch(filterSearchSourcingOptions4())
            // Sourcing supplier Clear filter
            store.dispatch(filterSourcingSupplierInput1())
            store.dispatch(filterSourcingSupplierOptions2())
            store.dispatch(filterSourcingSupplierOptions3())
            store.dispatch(filterSourcingSupplierOptions4())
            store.dispatch(filterSourcingSupplierOptionsEventType())
            // seal clear
            store.dispatch(filterSearchSourcingOptions5())
            // clear date from
            store.dispatch(filterDateFrom())
            // clear date to
            store.dispatch(filterDateTo())
            // clear filter Status
            store.dispatch(filterStatusSourcingProjects())
            // clear Sourcing Event
            store.dispatch(searchEventListSearch())
            store.dispatch(searchEventListAllEventType())
            store.dispatch(searchEventListAllStatus())
            store.dispatch(searchEventListSealStatus())
            store.dispatch(searchEventListAllAward())
            store.dispatch(searchEventListAllUser())
            // clear page
            store.dispatch(filterPage())
            store.dispatch(filterPageAllEvent())
          }
        }
        break
      case compareComponent.sourcing:
        {
          if (active) {
            store.dispatch(filterSearchInput(''))
            store.dispatch(filterSearchOptions(''))
            store.dispatch(filterSearchInput1(''))
            store.dispatch(filterSearchOptions2(''))
            store.dispatch(filterSearchOptions3(''))
            store.dispatch(filterSearchOptions4(''))
          }
        }
        break
      case compareComponent.complianceManagement:
        {
          if (active) {
            store.dispatch(filterSearchInput(''))
            store.dispatch(filterSearchOptions(''))
            store.dispatch(filterSearchInput1(''))
            store.dispatch(filterSearchOptions2(''))
            store.dispatch(filterSearchOptions3(''))
            store.dispatch(filterSearchOptions4(''))
            // Sourcing Clear filter
            store.dispatch(filterSearchSourcingInput1())
            store.dispatch(filterSearchSourcingOptions2())
            store.dispatch(filterSearchSourcingOptions3())
            store.dispatch(filterSearchSourcingOptions4())
            // Sourcing supplier Clear filter
            store.dispatch(filterSourcingSupplierInput1())
            store.dispatch(filterSourcingSupplierOptions2())
            store.dispatch(filterSourcingSupplierOptions3())
            store.dispatch(filterSourcingSupplierOptions4())
            // seal clear
            store.dispatch(filterSearchSourcingOptions5())
            // clear date from
            store.dispatch(filterDateFrom())
            // clear date to
            store.dispatch(filterDateTo())
            // clear filter Status
            store.dispatch(filterStatusSourcingProjects())
            // clear Sourcing Event
            store.dispatch(searchEventListSearch())
            store.dispatch(searchEventListAllStatus())
            store.dispatch(searchEventListSealStatus())
            store.dispatch(searchEventListAllAward())
            store.dispatch(searchEventListAllUser())
            // clear page
            store.dispatch(filterPage())
            store.dispatch(filterPageAllEvent())
          }
        }
        break
      default:
        break
    }
  }

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //   this.renderIcon()
  // }

  render() {
    const {
      children,
      submenu,
      defaultIconSrc,
      activeIconSrc,
      iconAlt,
      className,
      isDisable,
      activeKey,
      onClick,
      name,
    } = this.props

    const { isSupMenuOpen } = this.state

    const styleSidebar = {
      height: 'unset',
      backgroundColor: 'transparent',
      color: '#e3e1ff',
    }

    const isActive = activeKey === name
    const icon = this.state.isHover || isActive ? activeIconSrc : defaultIconSrc

    return (
      <SideBarItemStyle
        className={ClassNames(
          'sidebar-item',
          { 'is-disable': isDisable },
          { 'is-active': isActive },
          className
        )}
        onMouseEnter={() => this.setState({ isHover: true })}
        onMouseLeave={() => this.setState({ isHover: false })}
        onClick={children === 'Risk Management' ? null : onClick}
        key={name}
        style={isSupMenuOpen ? styleSidebar : { height: 'auto' }}
      >
        {children === 'Risk Management' || children === 'User Guideline' ? (
          <Section>
            <Accordion className="sidebar" isOpen={isSupMenuOpen}>
              <Accordion.Head
                onClick={() => this.setState({ isSupMenuOpen: !isSupMenuOpen })}
              >
                {isSupMenuOpen ? (
                  <Image src={defaultIconSrc} alt={iconAlt} />
                ) : (
                  <Image src={icon} alt={iconAlt} />
                )}
                <Section
                  className="menu-name"
                  style={
                    isSupMenuOpen
                      ? { color: '#e3e1ff' }
                      : isActive
                      ? { color: 'white' }
                      : {}
                  }
                >
                  {children}
                </Section>
              </Accordion.Head>
              <Accordion.Body>
                {submenu.map((e, i) => (
                  <div
                    key={e.name}
                    onClick={e.onClick}
                    className={ClassNames('menu-children', {
                      'isActive-children': activeKey === e.name,
                    })}
                  >
                    <div className="icon-spacing"></div>
                    <div>{e.name}</div>
                  </div>
                ))}
              </Accordion.Body>
            </Accordion>
          </Section>
        ) : (
          <Section>
            <Image src={icon} alt={iconAlt} />
            <div className="menu-name">{children}</div>
          </Section>
        )}
      </SideBarItemStyle>
    )
  }
}

const SidebarBrand = () => (
  <Link className="sidebar-brand" to={ROUTE_PATH.HOME.LINK}>
    <span className="sidebar-brand-mark" aria-hidden="true">
      <svg viewBox="0 0 24 24">
        <path d="M12 2l2.4 4.86L20 7.7l-4 3.9.94 5.4L12 14.5l-4.94 2.5L8 11.6 4 7.7l5.6-.84L12 2z" />
      </svg>
    </span>
    <span className="sidebar-brand-text">
      <span className="sidebar-brand-name">ASTRO</span>
      <span className="sidebar-brand-sub">E-Procurement</span>
    </span>
  </Link>
)

export class SideBar extends React.PureComponent {
  static Item = SideBarItem

  render() {
    const { children, className } = this.props

    return (
      <SideBarStyle className={ClassNames('sidebar', className)}>
        <SidebarBrand />
        {children}
      </SideBarStyle>
    )
  }
}

SideBarItem.defaultProps = {
  iconAlt: 'image',
  activeKey: '',
}
